import React, { useState, useEffect } from "react";
import { Alert, Button, Row, Col, Spinner } from "react-bootstrap";
import { checkEligibility } from "../../mediKreditapi";
import { jwtDecode } from "jwt-decode";
import { getUserPracticeById } from "../../api";

export default function CheckEligibility({ patient, account, onEligibility }) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false); // ✅ State for error message
  const [eligibilityResponse, setEligibilityResponse] = useState(null); // ✅ State for eligibility response
  const [practice, setPractice] = useState(null); // ✅ State for practice
  // ✅ If account exists, use its medical aid details. Otherwise, allow manual input.
  useEffect(() => {
      async function fetchData() {
        try {
          const token = sessionStorage.getItem("user");
          if (!token) throw new Error("No user token found");
  
          const user = jwtDecode(token);
          const practices = await getUserPracticeById(user._id);
          setPractice(practices[0]); // ✅ Set practice from user data

        } catch (error) {
          console.error("❌ Error loading Ozow data:", error);
        } finally {
          setLoading(false);
        }
      }
      console.log("Practice data:", practice);
      fetchData();
    }, []);
  
  const medicalAidInfo = {
    plan: account?.accountMediKreditPlanNumber03,
    ch_id: account?.accountMedicalAidNumber,
    sname: account?.accountLastName,
    inits: account?.accountInitials,
  };

  const practiceInfo = {
    sp_bhf: practice?.practiceNumber, //"0387495",
    sp_hpc: practice?.hpcsaNumber,
    grp_prac: practice?.practiceNumber
  };

  const patientInfo = {
    dep_cd: patient.patientMedicalAidDependantCode,
    dob: patient.patientDOB,
    id_nbr: patient.patientIdNumber,
    fname: patient.patientFirstName,
    sname: patient.patientLastName,
    pinits: patient.patientInitials,
    gend: patient.patientGender,
    rlnship: "",
    status: patient.patientStatus,
  };

  // ✅ Fetch dependants based on provided medical aid details
  async function Eligibility(e) {
    setLoading(true);
    try {
      const response = await checkEligibility(
        practiceInfo,
        medicalAidInfo,
        patientInfo
      );
      setEligibilityResponse(response); // ✅ Set eligibility response
      if (typeof onEligibility === "function") {
        onEligibility(response);
      }
    } catch (error) {
      if (
        error.response &&
        (error.response.status === 404 || error.response.status === 503)
      ) {
        setErrorMessage(true); // ✅ Set error message for 404/503
      }
    } finally {
      setLoading(false); // ✅ Reset loading state
    }
  }

  return (
    <>
      <Row>
        <Button
          className="ms-2 mt-0 me-2"
           style={{ width: "175px" }}
          onClick={Eligibility}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Loading...
            </>
          ) : (
            <>
              <i className="fa-solid fa-magnifying-glass me-2"></i>
              Check Status
            </>
          )}
        </Button>
      </Row>
      {errorMessage && (
        <Row className="mt-2">
          <Col md={10}>
            <Alert variant="danger" className="text-center mb-2">
              Service unavailable.
            </Alert>
          </Col>
        </Row>
      )}
      <Row className="mt-2">
      {eligibilityResponse?.eligibilityInfo && (
  <div
    className={
      eligibilityResponse.eligibilityInfo.status === "A"
        ? "text-success fw-bold"
        : "text-danger fw-bold"
    }
  >
    {eligibilityResponse.eligibilityInfo.status === "A"
      ? "Success"
      : eligibilityResponse.eligibilityInfo.status === "R"
      ? "Rejected"
      : eligibilityResponse.eligibilityInfo.status || "Unknown Status"}
  </div>
)}

      </Row>
      <Row className="mt-0">
        {eligibilityResponse?.eligibilityInfo?.warning &&
          (eligibilityResponse.eligibilityInfo.warning.code ||
            eligibilityResponse.eligibilityInfo.warning.description ||
            eligibilityResponse.eligibilityInfo.warning.RMRtype) && (
            <p className="text-secondary mb-1">
              {eligibilityResponse.eligibilityInfo.warning.code}{" "}
              {eligibilityResponse.eligibilityInfo.warning.description}{" "}
              {eligibilityResponse.eligibilityInfo.warning.RMRtype}
            </p>
          )}

        {eligibilityResponse?.eligibilityInfo?.fundWarning &&
          (eligibilityResponse.eligibilityInfo.fundWarning.code ||
            eligibilityResponse.eligibilityInfo.fundWarning.description ||
            eligibilityResponse.eligibilityInfo.fundWarning.RMRtype) && (
            <p className="text-secondary mb-1">
              {eligibilityResponse.eligibilityInfo.fundWarning.code}{" "}
              {eligibilityResponse.eligibilityInfo.fundWarning.description}{" "}
              {eligibilityResponse.eligibilityInfo.fundWarning.RMRtype}
            </p>
          )}

        {eligibilityResponse?.eligibilityInfo?.rejection &&
          (eligibilityResponse.eligibilityInfo.rejection.code ||
            eligibilityResponse.eligibilityInfo.rejection.description) && (
            <p className="text-danger mb-1">
              {eligibilityResponse.eligibilityInfo.rejection.code}{" "}
              {eligibilityResponse.eligibilityInfo.rejection.description}
            </p>
          )}

        {eligibilityResponse?.eligibilityInfo?.fundRejection &&
          (eligibilityResponse.eligibilityInfo.fundRejection.code ||
            eligibilityResponse.eligibilityInfo.fundRejection.description) && (
            <p className="text-danger mb-1">
              {eligibilityResponse.eligibilityInfo.fundRejection.code}{" "}
              {eligibilityResponse.eligibilityInfo.fundRejection.description}
            </p>
          )}

        {eligibilityResponse?.eligibilityInfo &&
          !(
            (eligibilityResponse.eligibilityInfo.warning &&
              (eligibilityResponse.eligibilityInfo.warning.code ||
                eligibilityResponse.eligibilityInfo.warning.description ||
                eligibilityResponse.eligibilityInfo.warning.RMRtype)) ||
            (eligibilityResponse.eligibilityInfo.fundWarning &&
              (eligibilityResponse.eligibilityInfo.fundWarning.code ||
                eligibilityResponse.eligibilityInfo.fundWarning.description ||
                eligibilityResponse.eligibilityInfo.fundWarning.RMRtype)) ||
            (eligibilityResponse.eligibilityInfo.rejection &&
              (eligibilityResponse.eligibilityInfo.rejection.code ||
                eligibilityResponse.eligibilityInfo.rejection.description)) ||
            (eligibilityResponse.eligibilityInfo.fundRejection &&
              (eligibilityResponse.eligibilityInfo.fundRejection.code ||
                eligibilityResponse.eligibilityInfo.fundRejection.description))
          ) && (
            <p className="fw-bold text-success mt-1 mb-1">Check Successful</p>
          )}

        {eligibilityResponse?.eligibilityInfo && (
          <p className="mb-0">
            HNET: {eligibilityResponse.eligibilityInfo.hnetNumber}
            <br />
            TXNR: {eligibilityResponse.eligibilityInfo.txNumber}
          </p>
        )}
      </Row>
    </>
  );
}
